// Catalog search bundle
import '../css/pages/catalog/search/search.css';

import { runLegacy } from './helpers/load-legacy';
import twbsPaginationJs from '../js/vendor/jquery.twbsPagination.js?legacy';
import searchJs         from '../js/pages/catalog/search/search.js?legacy';

runLegacy(
    twbsPaginationJs,
    searchJs,
);
